import styled from 'styled-components';
import {UsefulLinksListDefaultBox} from './useful-links-list.default.box';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';

export const UsefulLinksListCasino888CipBox = styled(UsefulLinksListDefaultBox)`
    border-radius: 10px;
    text-align: center;
    padding: 10px;
    
    ${CssRule.For.mobile.tablet.build()} & {
        padding: 0;
        border-radius: 0;
        min-width: 50rem;
    }
`;